import React, { useState, useEffect, useMemo } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import AddUomModal from "../components/addUomModal";
import EditUomModal from "../components/editUomModal";

const UOMMaster = () => {
   useAuthRedirect();
  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
//   const [formData, setFormData] = useState({ deptNo: "" });
  const [formData, setFormData] = useState({ branch: "", code: "", name: "", user: "" });

  /////////////////////////////////////////////////////////////
        const rawPerms = useMemo(() => localStorage.getItem("permissions") || localStorage.getItem("userPermissions"), []);
          const permsLoaded = !!rawPerms;
          
          //✅ Permission checks (safe even if perms not yet loaded; will be false)
          const canView  = hasPermission("Unit Of Measurement", "view");
          const canEntry = hasPermission("Unit Of Measurement", "entry");
          const canEdit = hasPermission("Unit Of Measurement", "edit");
          const canDel = hasPermission("Unit Of Measurement", "del");
          /////////////////////////////////////////////////////////////


  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/uomMaster_list`);

      console.log("API Response:", response.data.uomList);
      setData(response.data.uomList);
      setFilteredData(response.data.uomList);
    } catch (error) {
      console.error("Error fetching uomList:", error);
    } finally {
      setLoading(false);
    }
  };



const handleDelete = async (id) => {
  try {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    });

    Swal.fire({
                title: "Submitting...",
                text: "Please wait while we process your request.",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

    if (result.isConfirmed) {
      await axios.delete(`https://rfs2.infraconsoft.net.in/api/uomMaster_delete/${id}`);

      setData((prevData) =>
        prevData.filter((item) => item.uommaster_code !== id)
      );

      setFilteredData((prevFilteredData) =>
        prevFilteredData.filter((item) => item.uommaster_code !== id)
      );

      Swal.fire({
        title: "Deleted!",
        text: "Your record has been deleted.",
        icon: "success"
      });
    }
  } catch (error) {
    console.error("Error deleting department:", error);
    Swal.fire({
      title: "Error!",
      text: "Failed to delete department.",
      icon: "error"
    });
  }
};


useEffect(() => {
    const fetchPoNo = async () => {
      try {
         Swal.fire({
            title: "Fetching UOM Code",
            html: `
              <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
              </div>
              <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch UOM Code...</p>
            `,
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
              const style = document.createElement("style");
              style.innerHTML = `
                @keyframes progressBar {
                  0% { width: 0% }
                  50% { width: 100% }
                  100% { width: 0% }
                }
              `;
              document.head.appendChild(style);
            },
          });
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/uomMaster_addNo`);
        if (response.data.no) {
          setFormData((prevState) => ({
            ...prevState,
            code: response.data.no,
            user: formData.user,
            branch : formData.branch
          }));
        }
        Swal.close();
      } catch (error) {
         Swal.close();
          console.error("Error fetching UOM Code. Please try again:", error);
          Swal.fire({
            icon: "error",
            title: "Oops!",
            text: "Error fetching UOM Code. Please try again",
          });
      }
    };
    {canEntry && (
    fetchPoNo()
    )}
  }, []);
  
  const openAddModal = () => {
    setIsAddModalOpen(true);
  };

  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editFormData, setEditFormData] = useState({ code: "", name: "" });
    
    const openEditModal = (item) => {
        setEditFormData({ code: item.uommaster_code, name: item.uommaster_shortName, longName: item.uommaster_longName });
        setIsEditModalOpen(true);
    };
    
    const closeEditModal = () => {
        setIsEditModalOpen(false);
    };

     if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }
  

  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.uommaster_shortName || "").toLowerCase().includes(term) ||
    String(item.uommaster_longName || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Unit of Measurement</h2>
          <Time />
        </section>



        {/* Add New Button */}
        {canEntry && (
        <div className="add-new-container">
        <button className="add-new-btn" onClick={() => openAddModal()}>
              <i className="fa-solid fa-plus" ></i> Add New
            </button>
        </div>
        )}

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by UOM Name"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>UOM Code</th>
                <th>UOM Short Name</th>
                <th>UOM Long Name</th>
                {canEdit && (
                <th>Modify</th>
                )}
                {canDel && (
                <th>Delete</th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.uommaster_code}</td>
                    <td>{item.uommaster_shortName}</td>
                    <td>{item.uommaster_longName}</td>
                    {canEdit && (
                    <td onClick={() => openEditModal(item)} style={{color : "#030d68", fontWeight: "bold", cursor: "pointer"}}>Modify</td>
                    )}
                    {canDel && (
                    <td className="del">
                      <i className="fa-solid fa-trash-can " onClick={() => handleDelete(item.uommaster_code)}></i>
                    </td>
                    )}
                    
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
      <AddUomModal isAddOpen={isAddModalOpen} onAddClose={closeAddModal} formData={formData}  setFormData={setFormData} fetchData={fetchData} user={user} branch={branch}/>
      <EditUomModal
    isOpen={isEditModalOpen}
    onClose={closeEditModal}
    editFormData={editFormData}
    setEditFormData={setEditFormData}
    fetchData={fetchData} branch={branch}
/>
    </div>
  );
};

export default UOMMaster;
